/**
 * Debounce that always runs the function held in `ref` when the timer fires, not the one that
 * existed when it was created. The old list kept `useCallback(debounce(getAllData), [])`, which
 * froze the first render's getAllData and dropped the sort and price filter while typing.
 */
export type LatestDebounced = (() => void) & { cancel: () => void; flush: () => void };

export function latestDebounce(ref: { current: () => void }, delay: number): LatestDebounced {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const run = (() => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = undefined;
      ref.current();
    }, delay);
  }) as LatestDebounced;
  run.cancel = () => {
    if (timer) clearTimeout(timer);
    timer = undefined;
  };
  run.flush = () => {
    run.cancel();
    ref.current();
  };
  return run;
}
